import { render, staticRenderFns } from "./Newsensitivity.vue?vue&type=template&id=ac554f36&scoped=true&"
import script from "./Newsensitivity.vue?vue&type=script&lang=js&"
export * from "./Newsensitivity.vue?vue&type=script&lang=js&"
import style0 from "./Newsensitivity.vue?vue&type=style&index=0&id=ac554f36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac554f36",
  null
  
)

export default component.exports